export const isTestServer = (): boolean => {
  return /^cms\.test./i.test(location.hostname);
};

export const addEnviromentToHref = (href: string): string => {
  if (!isTestServer()) {
    return href;
  }

  const url = new URL(href);

  const subdomain = location.hostname.split(".")[1];
  url.hostname = url.hostname.replace("api", `api.${subdomain}`);
  url.protocol = location.protocol;

  return url.href.replace(/\/$/, "");
};



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/core/utils/enviroments-url.ts